import { party1Of, contractSections } from "@/lib/partner";

// Renders a printable-style contract document for on-screen reading (agreement | authorization)
export function ContractDocument({ type, data }) {
  const s = contractSections(type, data);
  const P1 = party1Of(data);
  return (
    <div className="bg-white text-slate-800 rounded-xl border border-slate-200 p-6 sm:p-8 shadow-sm" data-testid={`contract-${type}`}>
      <div className="text-center border-b-2 border-[#D96635] pb-5 mb-6" data-testid="contract-letterhead">
        <img src="/logo-letterhead.png" alt="Bedsolving Indonesia" className="h-20 mx-auto object-contain" />
        <p className="text-[11px] text-slate-500 mt-2 tracking-wide">bedsolvingindonesia@gmail.com · ops.bedsolving.id · Bali, Indonesia</p>
      </div>
      <div className="text-center mb-5">
        <h2 className="font-display text-xl font-bold tracking-tight text-[#1F1B16]">{s.title}</h2>
        <p className="text-xs text-slate-500 mt-1">{s.subtitle}</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 mb-5 text-sm">
        <div className="rounded-lg bg-slate-50 p-3">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400 mb-1">Party 1</p>
          <p><span className="text-slate-500">Name:</span> {P1.name}</p>
          <p><span className="text-slate-500">Title:</span> {P1.title}</p>
          <p><span className="text-slate-500">Contact:</span> {P1.contact}</p>
          <p><span className="text-slate-500">Company:</span> {P1.company}</p>
        </div>
        <div className="rounded-lg bg-slate-50 p-3">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400 mb-1">Party 2</p>
          <p><span className="text-slate-500">Name:</span> {data.partner_name || "—"}</p>
          <p><span className="text-slate-500">Title:</span> {data.partner_title || "—"}</p>
          <p><span className="text-slate-500">Contact:</span> {data.partner_contact || "—"}</p>
          <p><span className="text-slate-500">Company:</span> {data.partner_company || "—"}</p>
        </div>
      </div>

      <div className="space-y-4 text-sm leading-relaxed">
        {s.blocks.map((b, i) => (
          <div key={i} className={b.highlight ? "rounded-lg border border-amber-200 bg-amber-50 p-3" : ""}>
            {b.heading && <p className={`font-semibold text-sm mb-1.5 ${b.highlight ? "text-amber-800" : ""}`}>{b.heading}</p>}
            <div className={b.highlight ? "text-amber-900" : ""}>
              {(b.paragraphs || []).map((t, j) => <p key={j} className="whitespace-pre-wrap mb-1 last:mb-0">{t}</p>)}
              {b.items && (
                <ul className="list-disc pl-5 space-y-1">
                  {b.items.map((t, j) => <li key={j}>{t}</li>)}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-6 mt-8 pt-4 border-t border-slate-200">
        <div>
          <p className="text-xs text-slate-500 mb-1">Authorized representative — {P1.name}</p>
          {data.admin_signature ? (
            <img src={data.admin_signature} alt="Party 1 signature" className="h-16 object-contain" data-testid="admin-sig-img" />
          ) : (
            <div className="h-16 flex items-center text-xs text-slate-400 italic">Not signed yet</div>
          )}
          <div className="border-t border-slate-300 pt-1 text-[11px] text-slate-500">{data.admin_signed_at ? new Date(data.admin_signed_at).toLocaleDateString("en-GB") : ""}</div>
        </div>
        <div>
          <p className="text-xs text-slate-500 mb-1">Authorized representative — {data.partner_name || "Partner"}</p>
          {data.partner_signature ? (
            <img src={data.partner_signature} alt="Party 2 signature" className="h-16 object-contain" data-testid="partner-sig-img" />
          ) : (
            <div className="h-16 flex items-center text-xs text-slate-400 italic">Not signed yet</div>
          )}
          <div className="border-t border-slate-300 pt-1 text-[11px] text-slate-500">{data.partner_signed_at ? new Date(data.partner_signed_at).toLocaleDateString("en-GB") : ""}</div>
        </div>
      </div>

      <p className="text-center text-[11px] text-slate-400 mt-6">TRUSTED PARTNER SINCE 2014</p>
    </div>
  );
}
